<template>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-subheader ">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="m-subheader__title m-subheader__title--separator">
                        Owner
                    </h3>
                    <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                        <li class="m-nav__item m-nav__item--home">
                            <router-link exact :to="{ name: 'home' }" class="m-nav__link m-nav__link--icon">
                                <i class="m-nav__link-icon la la-home"></i>
                            </router-link>
                        </li>
                        <li class="m-nav__separator">
                            -
                        </li>
                        <li class="m-nav__item">
                            <router-link exact :to="{ name : 'owner' }" class="m-nav__link"><span
                                    class="m-nav__link-text">Owner</span>
                            </router-link>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
        <div class="m-content">
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Owners table
                                <small>
                                    List of all owners
                                </small>
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                    </div>
                </div>
                <div class="m-portlet__body">
                    <!--begin: Search Form -->
                    <div class="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
                        <div class="row align-items-center">
                            <div class="col-xl-8 order-2 order-xl-1">
                                <div class="form-group m-form__group row align-items-center">
                                    <div class="col-md-4">
                                        <div class="m-input-icon m-input-icon--left">
                                            <input type="text" class="form-control m-input m-input--solid"
                                                   v-model="search"
                                                   placeholder="Search..." id="generalSearch">
                                            <span class="m-input-icon__icon m-input-icon__icon--left">
                                                <span><i class="la la-search"></i></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 order-1 order-xl-2 m--align-right">
                                <button v-b-modal="'newOwnerModal'"
                                        class="btn btn-brand m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                                    <span>
                                        <i class="la la-plus"></i>
                                        <span>New Owner</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-success alert-dismissible" role="alert" v-if="alertCreated">
                        <button type="button" class="close" aria-label="Close" @click="alertCreated=false"></button>
                        New owner created successfully
                    </div>
                    <div class="alert alert-success alert-dismissible" role="alert" v-if="alertUpdated">
                        <button type="button" class="close" aria-label="Close" @click="alertUpdated=false"></button>
                        Owner updated successfully
                    </div>
                    <!--end: Search Form -->
                    <div class="table-responsive">
                    <table class="table table-inverse " v-if="owners.length > 0">
                        <thead>
                        <tr>
                            <th>#</th>
                            <!-- <th>Thumbnail</th> -->
                            <th>Name</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Order Position</th>
                            <th style="width: 120px;">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="owner,index in filteredOwners">
                            <td> {{ index + 1 }}</td>
                            <!-- <td>
                                <owner-preview
                                        v-bind:gallery="JSON.parse(owner.thumbnail)"
                                />
                            </td> -->
                            <td>{{ owner.name }}</td>
                            <td class="">{{ stripLongText(owner.description) }}</td>
                            <td>
                                <span class="m-badge m-badge--wide"
                                      :class="[ owner.active ? 'm-badge--success' : 'm-badge--danger' ]">{{ owner.active ? "Active" : "Inactive" }}
                                </span>
                            </td>
                            <td>{{ owner.or  }}</td>
                            <td>
                                <button title="Edit details"
                                        class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                                        v-b-modal="'newOwnerModal'"
                                        @click="updateOwner(owner.id)">
                                    <i class="la la-edit"></i>

                                </button>
                                <button title="Delete" @click="deleteOwner(owner.id, owner.name)"
                                        class="btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill">
                                    <i class="la la-trash"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <b-pagination v-if="total > 0 && total > pageSize" align="right" size="md" :total-rows="total"
                                  v-model="page" :per-page="pageSize">
                    </b-pagination>
                </div>

            </div>
            <new-owner @clear-id="clearId"
                          @show-create-success-alert="showCreateSuccessAlert"
                          @show-update-success-alert="showUpdateSuccessAlert"
                          @clicked-reload="getList"
                          v-bind:ownerId="ownerId"
            />
        </div>
    </div>
</template>

<script>
    import ownerApi from '../../api/owner';
    import NewOwner from './NewOwner';
    import OwnerPreview from "./OwnerPreview";

    export default {
        components: {
            OwnerPreview,
            NewOwner,
        },
        name: "owner",
        data() {
            return {
                error: false,
                alertCreated: false,
                alertUpdated: false,
                search: '',
                message: '',
                page: 1,
                total: 0,
                pageSize: 15,
                ownerId: null,
                owners: [],
            }
        },
        watch: {
            page(val) {
                this.getList()
            },
            pageSize(val) {
                this.getList()
            }
        },
        computed: {
            filteredOwners: function () {
                return this.owners.filter((owner) => {
                    if (owner.name.match(this.search) || owner.description.match(this.search)) {
                        return owner;
                    }
                });
            }
        },
        beforeMount() {
            this.getList()
        },
        methods: {
            updateOwner(id) {
                this.ownerId = id;
                this.$bvModal.show('newOwnerModal');
            },
            getList() {
                ownerApi.getOwner(this, {
                    page: this.page,
                    pageSize: this.pageSize
                }, (context) => {
                })
            },
            updatePageSize(val) {
                this.pageSize = parseInt(val);
            },
            clearId() {
                this.ownerId = null;
                this.getList();
            },
            showCreateSuccessAlert() {
                this.alertCreated = true;
                this.alertUpdated = false;
            },
            showUpdateSuccessAlert() {
                this.alertCreated = false;
                this.alertUpdated = true;
            },
            stripLongText(text) {
                if (text.length > 100) {
                    return text.substring(0, 100) + '...';
                } else {
                    return text;
                }
            },
            deleteOwner(id, name) {
                let approve = confirm(`Do you want to remove owner: ${name} and its related (trail, trail event, trail report) ?`);

                if (approve !== false) {
                    ownerApi.removeOwner(this, id, (context) => {
                        this.getList();
                        this.alertCreated = false;
                        this.alertUpdated = false;
                    });
                }
            },

        }
    }
</script>

<style scoped>

</style>